import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { MarketsSearchComponent } from '../../markets/markets-search/markets-search.component';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateMarketSearchGuard {
  canDeactivate(component: MarketsSearchComponent): Observable<boolean> | boolean {
    component.storeUnsavedMarketsSearch();
    return true;
  }
}
